export default __webpack_public_path__ + "static/media/heartLikeDark.a604c8af.svg";